module.exports = __webpack_public_path__ + "static/media/Right Lateral.de6acf13.png";